var map = {
	"./baquetas.png": 1409,
	"./bateria.png": 1410,
	"./caja-maquillaje.png": 1411,
	"./camara.png": 1412,
	"./cana-pescar.png": 1413,
	"./checklist.png": 1414,
	"./cucharon.png": 1415,
	"./dentadura.png": 1416,
	"./escuadra.png": 1417,
	"./fonendo.png": 1418,
	"./guitarra.png": 1419,
	"./libreta-boligrafo.png": 1420,
	"./llave-inglesa.png": 1421,
	"./maletin.png": 1422,
	"./maniqui.png": 1423,
	"./mapa.png": 1424,
	"./mescladora.png": 1425,
	"./microfono.png": 1426,
	"./microscopio.png": 1427,
	"./mobil.png": 1428,
	"./pelota-americano.png": 1429,
	"./pelota-basquetbol.png": 1430,
	"./pelota-futbol.png": 1431,
	"./pelota-tenis.png": 1432,
	"./periodico.png": 1433,
	"./pincel.png": 1434,
	"./placa-electronica.png": 1435,
	"./sierra.png": 1436,
	"./silbato.png": 1437,
	"./telescopio.png": 1438
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1408;